import React, { memo } from 'react';
import { useIntl } from 'umi';
import SvgIcon from '@home/components/SvgIcon';

interface ICostWarningCmpProps {
  value?: string;
}

const CostWarningCmp = memo((props: ICostWarningCmpProps) => {
  const { value } = props;
  const { formatMessage } = useIntl();

  if (value !== 'user_cost_exceeded') {
    return null;
  }

  return (
    <div className="dba-cost-warning">
      <div className="dba-cost-warning__icon" aria-hidden="true">
        <SvgIcon type="agent-error" />
      </div>
      <span className="dba-cost-warning__text">
        {formatMessage({ id: 'dba_user_cost_exceeded_tip' })}
      </span>
    </div>
  );
});

CostWarningCmp.displayName = 'CostWarningCmp';

export default CostWarningCmp;
